export default {
  fn: (value) => value >= 0 && value <= 65535,
  message: 'Enter a valid port number between 0 and 65535'
};
